module.exports = __webpack_public_path__ + "img/bg.58656ce4.jpg";